// ================================
// == Tout le code de experiment.js
// ================================

import htmlKeyboardResponse from "@jspsych/plugin-html-keyboard-response"
import surveyText from "@jspsych/plugin-survey-text"
import instructions from "@jspsych/plugin-instructions"
import fullscreen from "@jspsych/plugin-fullscreen"
import callFunction from "@jspsych/plugin-call-function"

// Plugins locaux
import AttentionCheckPlugin from "../../vendor/stroop/plugins/jspsych-attention-check.js";
import PoldrackTextPlugin from "../../vendor/stroop/plugins/jspsych-poldrack-text.js";
import PoldrackCategorizePlugin from "../../vendor/stroop/plugins/jspsych-poldrack-categorize.js";

// generic task variables
var run_attention_checks = false
var attention_check_thresh = 0.45
var sumInstructTime = 0 //ms
var instructTimeThresh = 0 ///in seconds
var credit_var = 0
var choices = ["r", "g", "b"]


/////// static variables ///////

var getInstructFeedback = function() {
  return '<div class = centerbox><p class = center-block-text>' + feedback_instruct_text +
    '</p></div>'
}

// task specific variables
var congruent_stim = [{
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:red">RED</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'congruent',
    stim_color: 'red',
    stim_word: 'red',
    correct_response: "r"
  },
  key_answer: "r"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:blue">BLUE</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'congruent',
    stim_color: 'blue',
    stim_word: 'blue',
    correct_response: "b"
  },
  key_answer: "b"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:green">GREEN</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'congruent',
    stim_color: 'green',
    stim_word: 'green',
    correct_response: "g"
  },
  key_answer: "g"
}];

var incongruent_stim = [{
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:red">BLUE</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'incongruent',
    stim_color: 'red',
    stim_word: 'blue',
    correct_response: "r"
  },
  key_answer: "r"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:red">GREEN</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'incongruent',
    stim_color: 'red',
    stim_word: 'green',
    correct_response: "r"
  },
  key_answer: "r"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:blue">RED</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'incongruent',
    stim_color: 'blue',
    stim_word: 'red',
    correct_response: "b"
  },
  key_answer: "b"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:blue">GREEN</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'incongruent',
    stim_color: 'blue',
    stim_word: 'green',
    correct_response: "b"
  },
  key_answer: "b"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:green">RED</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'incongruent',
    stim_color: 'green',
    stim_word: 'red',
    correct_response: "g"
  },
  key_answer: "g"
}, {
  stimulus: '<div class = centerbox><div class = stroop-stim style = "color:green">BLUE</div></div>',
  data: {
    trial_id: 'stim',
    condition: 'incongruent',
    stim_color: 'green',
    stim_word: 'blue',
    correct_response: "g"
  },
  key_answer: "g"
}];

// Petits rappels pour l'utilisateur : touche R, B, G
var response_keys =
  '<ul list-text><li><span class = "large" style = "color:red">MOT</span> : touche "R"</li><li><span class = "large" style = "color:blue">MOT</span> : touche "B"</li><li><span class = "large" style = "color:green">MOT</span> : touche "G"</li></ul>'

var feedback_instruct_text =
  'Bienvenue dans cette expérience. Elle dure environ 8 minutes. Appuyez sur <strong>Entrée</strong> pour commencer.'

var getInstructFeedback = function() {
  return '<div class = centerbox><p class = center-block-text>' + feedback_instruct_text +
    '</p></div>'
}

export function assessPerformance(jsPsych) {
  var experiment_data = jsPsych.data.get().filter({ trial_type: PoldrackCategorizePlugin }).values();
  var missed_count = 0
  var trial_count = 0
  var rt_array = []
  var rt = 0
  
  //record choices participants made
  var choice_counts = {}
  choice_counts[-1] = 0
  for (var k = 0; k < choices.length; k++) {
    choice_counts[choices[k]] = 0
  }

  for (var i = 0; i < experiment_data.length; i++) {
    if (experiment_data[i].possible_responses != 'none') {
      trial_count += 1
      rt = experiment_data[i].rt
      key = experiment_data[i].key_press
      choice_counts[key] += 1
      if (rt == -1) {
        missed_count += 1
      } else {
        rt_array.push(rt)
      }
    }
  }
  //calculate average rt
  var avg_rt = -1
  if (rt_array.length !== 0) {
    avg_rt = math.median(rt_array)
  } 
  //calculate whether response distribution is okay
  var responses_ok = true
  Object.keys(choice_counts).forEach(function(key, index) {
    if (choice_counts[key] > trial_count * 0.85) {
      responses_ok = false
    }
  })
  var missed_percent = missed_count / trial_count
  credit_var = (missed_percent < 0.4 && avg_rt > 200 && responses_ok)
  jsPsych.data.addDataToLastTrial({ "credit_var": credit_var })
}

function evalAttentionChecks() {
  var check_percent = 1
  if (run_attention_checks) {
    var attention_check_trials = jsPsych.data.getTrialsOfType(jsPsychAttentionCheck)
    var checks_passed = 0
    for (var i = 0; i < attention_check_trials.length; i++) {
      if (attention_check_trials[i].correct === true) {
        checks_passed += 1
      }
    }
    check_percent = checks_passed / attention_check_trials.length
  }
  return check_percent
}



/////// exported variables ///////

export var stims = [].concat(congruent_stim, congruent_stim, incongruent_stim)

export var enter_fullscreen = {
  type: fullscreen,
  fullscreen_mode: true,
  button_label: 'Continuer',
  message: '<p class = center-block-text>L\'expérience va passer en mode plein écran quand vous appuierez sur le bouton ci-dessous.</p>',
}



// TODO: needed ??
var exp_stage = 'practice'


// Set up attention check node
export var attention_check_block = {
  type: AttentionCheckPlugin,
  data: {
    trial_id: "attention_check"
  },
  trial_duration: 180000,
  response_ends_trial: true,
  timing_post_trial: 200
}

export var attention_node = {
  timeline: [attention_check_block],
  conditional_function: function() {
    return run_attention_checks
  }
}

// Post-task questionnaire
export var post_task_block = {
  type: surveyText,
  data: {
      trial_id: "post task questions"
  },
  questions: [
    {
      prompt: '<p class = center-block-text style = "font-size: 20px">Merci de résumer ce que vous deviez faire dans cette tâche.</p>',
      rows: 15,
      columns: 60,
      required: true
    },
    {
      prompt: '<p class = center-block-text style = "font-size: 20px">Avez-vous des commentaires à faire sur cette tâche ?</p>',
      rows: 15,
      columns: 60,
      required: false
    }
  ]
};




export var feedback_instruct_block = {
  type: PoldrackTextPlugin,
  data: {
    trial_id: "instruction"
  },
  cont_key: [13],
  text: getInstructFeedback,
  timing_post_trial: 0,
  trial_duration: 180000
};


// Bloque instructions
export var instructions_block = {
  type: instructions,
  data: {
    trial_id: "instruction"
  },
  pages: [
    '<div class = centerbox><p class = block-text>Dans cette expérience, vous verrez des mots de couleur (RED, BLUE, GREEN) apparaître un à un. L\'<em>encre</em> des mots sera aussi colorée. Par exemple, vous pourrez voir : <span class = "large" style = "color:blue">RED</span>, <span class = "large" style = "color:blue">BLUE</span> ou <span class = "large" style = "color:red">BLUE</span>.</p><p class = block-text>Votre tâche consiste à appuyer sur la touche correspondant à la <strong>couleur de l\'encre</strong> du mot. Il est important de répondre le plus rapidement et précisément possible. Les touches de réponse sont :</p>' +
    response_keys + '</div>'
  ],
  allow_keys: true,
  show_clickable_nav: true,
  button_label_previous: "Précédent",
  button_label_next: "Suivant",
  key_forward: "ArrowRight",
  key_backward: "ArrowLeft",
  allow_backward: true
};

export var instruction_node = {
  timeline: [feedback_instruct_block, instructions_block],
  loop_function: function(data) {
    for (var i = 0; i < data.length; i++) {
      if ((data[i].trial_type == 'poldrack-instructions') && (data[i].rt != -1)) {
        rt = data[i].rt
        sumInstructTime = sumInstructTime + rt
      }
    }
    console.log('sumInstructTime: ' + sumInstructTime);

    if (sumInstructTime <= instructTimeThresh * 1000) {
      feedback_instruct_text =
        'Vous avez lu les instructions trop rapidement. Prenez votre temps et assurez-vous de bien comprendre. Appuyez sur <strong>Entrée</strong> pour continuer.'
      return false
    } else if (sumInstructTime > instructTimeThresh * 1000) {
      feedback_instruct_text = 'Fin des instructions. Appuyez sur <strong>Entrée</strong> pour continuer.'
      return false
    }
  }
}

export var close_page_block = {
  type: PoldrackTextPlugin,
  data: {
    trial_id: "close_page"
  },
  trial_duration: 180000,
  text: '<div class = centerbox><p class = center-block-text>Le test est terminé !</p><p class = center-block-text>Les données ont été enregistrées et attachées au sujet. Vous pouvez fermer cette page</p></div>'
};

export var start_practice_block = {
  type: PoldrackTextPlugin,
  data: {
    trial_id: "practice_intro"
  },
  trial_duration: 180000,
  text: '<div class = centerbox><p class = block-text>Nous allons commencer avec quelques essais d\'entraînement. Rappelez-vous, appuyez sur la touche correspondant à la <strong>couleur de l\'encre</strong> du mot : "r" pour le rouge, "b" pour le bleu et "g" pour le vert.</p><p class = block-text>Appuyez sur <strong>Entrée</strong> pour commencer l\'entraînement.</p></div>',
  cont_key: [13],
  timing_post_trial: 1000
};

export var start_test_block = {
  type: PoldrackTextPlugin,
  data: {
    trial_id: "test_intro"
  },
  trial_duration: 180000,
  text: '<div class = centerbox><p class = center-block-text>Nous allons maintenant démarrer la partie test. Répondez exactement comme lors de l\'entraînement.</p><p class = center-block-text>Appuyez sur <strong>Entrée</strong> pour commencer le test.</p></div>',
  cont_key: [13],
  timing_post_trial: 1000,
  on_finish: function() {
    exp_stage = 'test'
  }
};


export function fixation_block(jsPsych) {
  return {
    type: htmlKeyboardResponse,
    stimulus: '<div class = centerbox><div class = fixation>+</div></div>',
    choices: 'NO_KEYS',
    data: {
      trial_id: "fixation"
    },
    timing_post_trial: 500,
    timing_stim: 500,
    trial_duration: 500,
    on_finish: function() {
      jsPsych.data.addDataToLastTrial({ 'exp_stage': exp_stage })
    },
  }
}



export function practice_block(jsPsych, practice_stims, i) {
  return {
    type: PoldrackCategorizePlugin,
    stimulus: practice_stims.stimulus[i],
    data: practice_stims.data[i],
    key_answer: practice_stims.key_answer[i],
    correct_text: '<div class = fb_box><div class = center-text><font size = 20>Correct !</font></div></div>',
    incorrect_text: '<div class = fb_box><div class = center-text><font size = 20>Faux !</font></div></div>',
    timeout_message: '<div class = fb_box><div class = center-text><font size = 20>Répondez plus vite !</font></div></div>',
    choices: choices,
    is_html: true,
    trial_duration: 1500,
    feedback_duration: 500,
    show_stim_with_feedback: false,
    post_trial_gap: 250,
    on_finish: function() {
      jsPsych.data.addDataToLastTrial({
        trial_id: 'stim',
        exp_stage: 'practice'
      })
    }
  }
}


export function test_block(jsPsych, test_stims, i) {
  return {
    type: PoldrackCategorizePlugin,
    stimulus: test_stims.stimulus[i],
    data: test_stims.data[i],
    key_answer: test_stims.key_answer[i],
    correct_text: '<div class = fb_box><div class = center-text><font size = 20>Correct !</font></div></div>',
    incorrect_text: '<div class = fb_box><div class = center-text><font size = 20>Faux !</font></div></div>',
    timeout_message: '<div class = fb_box><div class = center-text><font size = 20>Répondez plus vite !</font></div></div>',
    choices: choices,
    is_html: true,
    trial_duration: 1500,
    timing_feedback_duration: 500,
    show_stim_with_feedback: false,
    timing_post_trial: 250,
    on_finish: function() {
      jsPsych.data.addDataToLastTrial({
        trial_id: 'stim',
        exp_stage: 'test'
      })
    }
  }
}